import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
if (typeof document !== 'undefined') {
  const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/uz7iR2XBoKiwU5EPAYF5VA/Texto_del_parrafo_(3).webp';
  if (!document.querySelector('link[rel="preconnect"][href="https://cdn.magicpatterns.com"]')) {
    const pc = document.createElement('link');
    pc.rel = 'preconnect';
    pc.href = 'https://cdn.magicpatterns.com';
    document.head.insertBefore(pc, document.head.firstChild);
  }
  if (!document.querySelector(`link[rel="preload"][href="${HERO_IMAGE}"]`)) {
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.as = 'image';
    preload.href = HERO_IMAGE;
    (preload as any).fetchPriority = 'high';
    document.head.insertBefore(preload, document.head.firstChild);
  }
}
render(<App data-id="element-458" />, document.getElementById('root'));